import { createFileRoute, useSearch } from '@tanstack/react-router'
import type { JSX } from 'react'

import { ReportScreen } from './-components/report-screen.tsx'

/**
 * One Studio report. The document is the `id` search param, read loosely so a
 * typed `validateSearch` does not narrow every `navigate` call in the app.
 */
export const Route = createFileRoute('/studio/report')({
  component: ReportPage
})

function ReportPage(): JSX.Element {
  const search: Record<string, unknown> = useSearch({ strict: false })
  const id =
    typeof search.id === 'string' && search.id !== '' ? search.id : null
  return <ReportScreen key={id ?? 'none'} id={id} />
}
